import { createSelector } from 'reselect';
import { rateQuoteRequestSelector } from '../../selectors/rate-quote-request';

export const rqrSelector = createSelector(rateQuoteRequestSelector, rqr =>
  rqr
    .map(({ borrowerScenarioId, sourceId }) => ({ borrowerScenarioId, sourceId }))
    .orElse(() => ({ borrowerScenarioId: '', sourceId: '' }))
);
